import { Moon } from "lucide-react"
import { Button } from "@/components/ui/button"
import { SleepStepContainer } from "../SleepStepContainer"
import { useSleepForm } from "../SleepFormContext"

interface EnvironmentStepProps {
  environments: { id: string; description: string }[]
  childName?: string
  onNext: () => void
}

export function EnvironmentStep({ environments, childName, onNext }: EnvironmentStepProps) {
  const form = useSleepForm()

  return (
    <SleepStepContainer>
      <div className="space-y-2">
        <h3 className="text-lg font-medium text-center mb-4">
          How was {childName || 'your baby\'s'} sleep environment?
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto">
          {environments.map((env) => (
            <Button
              key={env.id}
              type="button"
              variant={form.watch("environment_id") === env.id ? "default" : "outline"}
              className="w-full py-3 px-4 h-auto text-left justify-start hover:bg-accent/50 whitespace-normal"
              onClick={() => {
                form.setValue("environment_id", env.id)
                form.clearErrors("environment_id")
                onNext()
              }}
            >
              <Moon className="mr-2 h-4 w-4 shrink-0" />
              <span className="text-sm line-clamp-2">{env.description}</span>
            </Button>
          ))}
        </div>
        {form.formState.errors.environment_id && (
          <p className="text-sm text-destructive">
            {form.formState.errors.environment_id.message}
          </p>
        )}
      </div>
    </SleepStepContainer>
  )
}